import { createSelector } from 'reselect'
import { agencyApiSelectors } from '../../api/agency'
import { EMPTY_AGENCY_PROFILE_FORM_VALUES } from '../../api/agency/constants'
import { TAgencyEntity, TAgencyProfileFormValues, TAgencyState, TAgencyTheme } from '../../api/agency/types'

export const getProfileInitialValues = createSelector(
  agencyApiSelectors.getCurrentAgency,
  (agency: TAgencyEntity | undefined): TAgencyProfileFormValues =>
    // The stored profile is partial on the wire; the form has always consumed it
    // as if complete. Asserting rather than merging keeps a saved profile round
    // -tripping with exactly the keys it arrived with.
    (agency?.agency as TAgencyProfileFormValues | undefined) ?? EMPTY_AGENCY_PROFILE_FORM_VALUES,
)

export const getBrandingInitialValues = createSelector(
  [agencyApiSelectors.getThemes, agencyApiSelectors.getCurrentAgencyTheme, agencyApiSelectors.getCurrentAgencyLogo],
  (
    themes: TAgencyState['themes'],
    currentTheme: TAgencyTheme | false,
    logo: string,
  ): { theme?: TAgencyTheme; logo: string } => ({
    theme: currentTheme || themes.find(t => t.name.toLowerCase() === 'black'),
    logo,
  }),
)
